import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Search } from "lucide-react";

const NotFound = () => (
  <section className="bg-slate-50 px-4 py-24">
    <div className="mx-auto max-w-xl text-center">
      <p className="font-display text-7xl font-extrabold text-navy-800">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold text-navy-800">We couldn't find that page</h1>
      <p className="mt-3 text-slate-600">The page may have moved. Try one of these instead:</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 rounded-xl bg-navy-800 px-5 py-3 font-bold text-white hover:bg-navy-900">
          <ArrowLeft className="h-4 w-4" aria-hidden /> Home
        </Link>
        <Link to="/admissions" className="rounded-xl bg-gold-400 px-5 py-3 font-bold text-navy-900 hover:bg-gold-300">
          Admissions
        </Link>
        <Link to="/ContactDetails" className="inline-flex items-center gap-2 rounded-xl bg-white px-5 py-3 font-bold text-navy-800 ring-1 ring-slate-300 hover:bg-slate-50">
          <Search className="h-4 w-4" aria-hidden /> Contact us
        </Link>
      </div>
    </div>
  </section>
);

export default NotFound;
